import React from 'react';

export const PayDisclaimer = () => {
  return (
    <span style={{ display: 'flex', textAlign: 'center', marginTop: '10px', fontSize: '12px', fontWeight: 600 }}>
      Al dar click en pagar se enviará tu pedido, asegurate que esté completo
    </span>
  );
};
